import { createContext, ReactNode, useCallback, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import AddedToCartModal from 'components/common/AddedToCartModal';

export interface AddedToCartItem {
  name: string;
  image?: string;
}

export interface AddedToCartContextProps {
  notify: (item: AddedToCartItem) => void;
}

export const AddedToCartContext = createContext<AddedToCartContextProps>({
  notify: () => null,
});

export const AddedToCartContextProvider = ({ children }: { children: ReactNode }) => {
  const [visible, setVisible] = useState(false);
  const [item, setItem] = useState<AddedToCartItem | null>(null);
  const { push } = useRouter();

  const notify = useCallback((newItem: AddedToCartItem) => {
    setItem(newItem);
    setVisible(true);
  }, []);

  const close = useCallback(() => setVisible(false), []);

  const checkout = useCallback(() => {
    setVisible(false);
    void push('/checkout');
  }, [push]);

  const values = useMemo(() => ({ notify }), [notify]);

  return (
    <AddedToCartContext.Provider value={values}>
      <AddedToCartModal
        visible={visible}
        productName={item?.name ?? ''}
        productImage={item?.image}
        onClose={close}
        onCheckout={checkout}
      />
      {children}
    </AddedToCartContext.Provider>
  );
};
